import { Component, inject } from '@angular/core';
import { EmployeeTableComponent as EpEmployeeTableComponent } from '@ep/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { Employee } from '@shared/models';
import { EmployeesApiService } from '@app/areas/merchants/services/employees.api.service';

@Component({
  selector: 'app-employee-table',
  templateUrl: './employee-table.component.html',
  styleUrls: ['./employee-table.component.scss'],
  standalone: true,
  imports: [EpEmployeeTableComponent, AsyncPipe],
})
export class EmployeeTableComponent {
  private readonly employeesApiService = inject(EmployeesApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected employees$: Observable<Employee[]> = this.route.parent!.parent!.paramMap.pipe(
    map((params) => Number(params.get('merchantId'))),
    switchMap((merchantId) => this.employeesApiService.getByMerchantId(merchantId))
  );

  protected addNew(): void {
    this.router.navigate(['new'], { relativeTo: this.route });
  }

  protected rowClick(employee: Employee): void {
    this.router.navigate([employee.EmployeeId], { relativeTo: this.route });
  }
}
